// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import {
    Divider,
    IconButton,
    Tooltip,
    Fab,
    MenuItem,
    InputLabel,
    Select,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Typography,
    CircularProgress,
    Autocomplete,
    TextField
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import { useToast } from '../../../components/ToastProvider'
import { Controller, useForm } from 'react-hook-form'
import { getPeriode } from '../../../api/helper'
import Swal from 'sweetalert2'

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();
    const [valPeriode, setValPeriode] = useState<any>(null)
    const [loading, setLoading] = useState<Boolean>(false)

    // ** State
    const [listData, setListData] = useState({
        aset_lancar: [],
        aset_tetap: [],
        liabilitas: [],
        ekuitas: []
    })
    const [listPeriode, setListPeriode] = useState<any[]>([])

    useEffect(() => {
        const fetchPeriode = async () => {
            const response = await getPeriode(token);
            setListPeriode(response);
        };

        fetchPeriode()
    }, [])

    const navigate = useNavigate();

    const getData = () => {
        if (!valPeriode) {
            Swal.fire({
                icon: 'warning',
                title: 'Periode belum dipilih',
                text: 'Silakan pilih periode terlebih dahulu'
            })
            return
        }

        setLoading(true)

        setListData({
            aset_lancar: [],
            aset_tetap: [],
            liabilitas: [],
            ekuitas: []
        })

        let url = apiUrl.apiUrl + '/acc/laporan-keuangan/list-neraca'

        axios
            .get(url, {
                params: {
                    periode: valPeriode.id, // ✅ FIX
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const res = response.data

                    setListData({
                        aset_lancar: res.data?.aset_lancar || res.aset_lancar || [],
                        aset_tetap: res.data?.aset_tetap || res.aset_tetap || [],
                        liabilitas: res.data?.liabilitas || res.liabilitas || [],
                        ekuitas: res.data?.ekuitas || res.ekuitas || [],
                    })
                }
            })
            .catch(() => {
                showToast('Terjadi kesalahan saat mengambil data', 'error')
            })
            .finally(() => setLoading(false))
    }

    interface FormInputs {
        periode: any
    }

    const defaultValues = {
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        watch,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const formatRupiah = (val) => {
        return new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR'
        }).format(val || 0)
    }

    const sumTotal = (arr = []) => {
        return arr.reduce((acc, item) => acc + (item.total || 0), 0)
    }

    const hasData =
        (listData?.aset_lancar?.length || 0) > 0 ||
        (listData?.aset_tetap?.length || 0) > 0 ||
        (listData?.liabilitas?.length || 0) > 0 ||
        (listData?.ekuitas?.length || 0) > 0

    const handleLihat = (item) => {
        if (!valPeriode) return

        const tglAwal = valPeriode?.tgl_awal
        const tglAkhir = valPeriode?.tgl_akhir

        const url = `/acc/buku-besar?tglAwal=${tglAwal}&tglAkhir=${tglAkhir}&akun=${item.akun}`

        window.open(url, '_blank')
    }

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='NERACA' />
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Grid
                            item
                            container
                            sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                            spacing={5}
                        >
                            <Grid item xs={4} sm={4}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valPeriode}
                                        options={listPeriode}
                                        isOptionEqualToValue={(option, value) => option.id === value?.id}
                                        getOptionLabel={(option) => option?.periode || ''}
                                        onChange={(event, newValue) => {
                                            setValPeriode(newValue)
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} label='Periode' />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={2} md={2}>
                                <FormControl fullWidth>
                                    <Button
                                        variant='contained'
                                        sx={{ mt: 1 }}
                                        startIcon={<Icon icon='mdi:magnify' />}
                                        onClick={getData}
                                    >
                                        Cari Data
                                    </Button>
                                </FormControl>
                            </Grid>
                            <Grid item xs={2} md={2}>
                                <FormControl fullWidth>
                                    <Button
                                        variant='contained'
                                        color='error'
                                        sx={{ mt: 1 }}
                                        startIcon={<Icon icon='mdi:file-pdf-box' />}
                                        onClick={() => {
                                            if (!valPeriode) {
                                                Swal.fire({
                                                    icon: 'warning',
                                                    title: 'Periode belum dipilih',
                                                    text: 'Silakan pilih periode terlebih dahulu'
                                                })
                                                return
                                            }

                                            const url = `https://api.mylittlefairies.online/acc/laporan/pdf/neraca?periode=${valPeriode?.id}`
                                            window.open(url, '_blank')
                                        }}
                                    >
                                        Lihat PDF
                                    </Button>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </CardContent>
                    {loading ? (
                        <Grid container spacing={3} sx={{ mt: 2, mb: 2, px: 3, justifyContent: 'center' }}>
                            <Grid container justifyContent="center" sx={{ mt: 5, mb: 5 }}>
                                <CircularProgress />
                            </Grid>
                        </Grid>
                    ) : hasData ? (
                        <Grid container spacing={3} sx={{ mt: 2, px: 3 }}>
                            {/* ===== ASET ===== */}
                            <Grid item xs={12} md={6}>
                                <Box sx={{ p: 2, border: '1px solid #eee', borderRadius: 2 }}>
                                    <h3>Aset</h3>

                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Nama Akun</TableCell>
                                                <TableCell align="right">Total</TableCell>
                                                <TableCell align="center">Aksi</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {/* ASET LANCAR */}
                                            <TableRow>
                                                <TableCell colSpan={3}><b>Aset Lancar</b></TableCell>
                                            </TableRow>

                                            {(listData.aset_lancar || []).map((item, i) => (
                                                <TableRow key={i}>
                                                    <TableCell>{item.nama_akun}</TableCell>
                                                    <TableCell align="right">{formatRupiah(item.total)}</TableCell>
                                                    <TableCell align="center">
                                                        <Button
                                                            size="small"
                                                            variant="outlined"
                                                            onClick={() => handleLihat(item)}
                                                        >
                                                            Lihat
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}

                                            {/* TOTAL ASET LANCAR */}
                                            <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                                <TableCell><b>Total Aset Lancar</b></TableCell>
                                                <TableCell align="right">
                                                    <b>{formatRupiah(sumTotal(listData.aset_lancar))}</b>
                                                </TableCell>
                                                <TableCell />
                                            </TableRow>

                                            {/* ASET TETAP */}
                                            <TableRow>
                                                <TableCell colSpan={3}><b>Aset Tetap</b></TableCell>
                                            </TableRow>

                                            {(listData.aset_tetap || []).map((item, i) => (
                                                <TableRow key={i}>
                                                    <TableCell>{item.nama_akun}</TableCell>
                                                    <TableCell align="right">{formatRupiah(item.total)}</TableCell>
                                                    <TableCell align="center">
                                                        <Button
                                                            size="small"
                                                            variant="outlined"
                                                            onClick={() => handleLihat(item)}
                                                        >
                                                            Lihat
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}

                                            {/* TOTAL ASET TETAP */}
                                            <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                                <TableCell><b>Total Aset Tetap</b></TableCell>
                                                <TableCell align="right">
                                                    <b>{formatRupiah(sumTotal(listData.aset_tetap))}</b>
                                                </TableCell>
                                                <TableCell />
                                            </TableRow>

                                            {/* GRAND TOTAL ASET */}
                                            <TableRow sx={{ bgcolor: '#e3f2fd' }}>
                                                <TableCell><b>Total Aset</b></TableCell>
                                                <TableCell align="right">
                                                    <b>
                                                        {formatRupiah(
                                                            sumTotal(listData.aset_lancar) +
                                                            sumTotal(listData.aset_tetap)
                                                        )}
                                                    </b>
                                                </TableCell>
                                                <TableCell />
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </Box>
                            </Grid>

                            {/* ===== LIABILITAS & EKUITAS ===== */}
                            <Grid item xs={12} md={6}>
                                <Box sx={{ p: 2, border: '1px solid #eee', borderRadius: 2 }}>
                                    <h3>Liabilitas & Ekuitas</h3>

                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Nama Akun</TableCell>
                                                <TableCell align="right">Total</TableCell>
                                                <TableCell align="center">Aksi</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {/* LIABILITAS */}
                                            <TableRow>
                                                <TableCell colSpan={3}><b>Liabilitas</b></TableCell>
                                            </TableRow>

                                            {(listData.liabilitas || []).map((item, i) => (
                                                <TableRow key={i}>
                                                    <TableCell>{item.nama_akun}</TableCell>
                                                    <TableCell align="right">{formatRupiah(item.total)}</TableCell>
                                                    <TableCell align="center">
                                                        <Button
                                                            size="small"
                                                            variant="outlined"
                                                            onClick={() => handleLihat(item)}
                                                        >
                                                            Lihat
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}

                                            {/* TOTAL LIABILITAS */}
                                            <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                                <TableCell><b>Total Liabilitas</b></TableCell>
                                                <TableCell align="right">
                                                    <b>{formatRupiah(sumTotal(listData.liabilitas))}</b>
                                                </TableCell>
                                                <TableCell />
                                            </TableRow>

                                            {/* EKUITAS */}
                                            <TableRow>
                                                <TableCell colSpan={3}><b>Ekuitas</b></TableCell>
                                            </TableRow>

                                            {(listData.ekuitas || []).map((item, i) => (
                                                <TableRow key={i}>
                                                    <TableCell>{item.nama_akun}</TableCell>
                                                    <TableCell align="right">{formatRupiah(item.total)}</TableCell>
                                                    <TableCell align="center">
                                                        <Button
                                                            size="small"
                                                            variant="outlined"
                                                            onClick={() => handleLihat(item)}
                                                        >
                                                            Lihat
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}

                                            {/* TOTAL EKUITAS */}
                                            <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                                <TableCell><b>Total Ekuitas</b></TableCell>
                                                <TableCell align="right">
                                                    <b>{formatRupiah(sumTotal(listData.ekuitas))}</b>
                                                </TableCell>
                                                <TableCell />
                                            </TableRow>

                                            {/* GRAND TOTAL */}
                                            <TableRow sx={{ bgcolor: '#e8f5e9' }}>
                                                <TableCell><b>Total Liabilitas + Ekuitas</b></TableCell>
                                                <TableCell align="right">
                                                    <b>
                                                        {formatRupiah(
                                                            sumTotal(listData.liabilitas) +
                                                            sumTotal(listData.ekuitas)
                                                        )}
                                                    </b>
                                                </TableCell>
                                                <TableCell />
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </Box>
                            </Grid>
                        </Grid>
                    ) : (
                        <Grid container spacing={3} sx={{ mt: 2, mb: 2, px: 3, justifyContent: 'center' }}>
                            <Typography align="center" sx={{ mt: 5, mb: 5 }}>
                                Tidak ada data
                            </Typography>
                        </Grid>
                    )}
                </div>
            </Grid>
        </Grid>
    )
}
